const Style = `
  <style>
    .accordion-advanced-body {
      display: none;
    }

    .accordion-advanced-body.active {
      display: block;
    }
  </style>
`;

export default Style;
